import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {
  refereshTokenInterval: any;

  constructor(private router: Router,) { }

  ngOnInit(): void {
  }

  goToLoginPage(): void {
    if (localStorage.loginToken) {
        this.router.navigateByUrl("console/alert-dashboard");
    }else{
      this.router.navigateByUrl("/");
    }
  }

}